import { FormulierProcessDependencies } from '../dependencies';

export const setIsComplete = async (value: boolean, deps: FormulierProcessDependencies) => {
  deps.dispatch(s => ({
    ...s,
    isComplete: value,
    isSuccessful: false,
    isLoading: false,
  }));
};

export const setIsLoading = async (value: boolean, deps: FormulierProcessDependencies) => {
  deps.dispatch(s => ({
    ...s,
    isLoading: value,
  }));
};
